const LVHernia = (props: { fill: string }) => (
	<>
		<mask id="mask0_1088_4927" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
			<rect width="32" height="32" fill="#D9D9D9" />
		</mask>
		<g mask="url(#mask0_1088_4927)">
			<path d="M14.6666 6.66667V13.3333H17.3333V6.66667H14.6666Z" fill={props.fill} />
			<path d="M20.7 14.7333L22.6 16.6333L27.3 11.9L25.4333 10.0333L20.7 14.7333Z" fill={props.fill} />
			<path d="M9.4 16.6333L4.7 11.9L6.56667 10.0333L11.3 14.7333L9.4 16.6333Z" fill={props.fill} />
			<path
				d="M4 24H9.46802C9.55294 23.5841 9.67758 23.1762 9.8408 22.7821C10.1758 21.9733 10.6669 21.2384 11.2859 20.6196C11.9049 20.0008 12.6398 19.5097 13.4488 19.1741C14.2577 18.8384 15.1713 18.6667 16 18.6667C16.8287 18.6667 17.7423 18.8384 18.5512 19.1741C19.3602 19.5097 20.0951 20.0008 20.7141 20.6196C21.3331 21.2384 21.8242 21.9733 22.1592 22.7821C22.3224 23.1762 22.447 23.5841 22.532 24H28V26H4V24Z"
				fill={props.fill}
			/>
		</g>
	</>
);

export default LVHernia;
